export { default } from "ember-stereo/-private/utils/metadata-cache";
